<template>
  <textarea
    class="comment-input"
    ref="myTextarea"
    :value="value"
    @input="handleInput"
    :placeholder="placeholder"
  >
  </textarea>
</template>

<script>
import autosize from 'autosize';

export default {
  name: 'CommentInput',
  props: {
    value: {
      type: String,
      require: true,
      default: '',
    },
    placeholder: {
      type: String,
      require: false,
      default() {
        return this.$t('common.commentPh');
      },
    },
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value);
    },
  },
  mounted() {
    autosize(this.$refs.myTextarea);
  },
};
</script>

<style lang="scss" scoped>
  .comment-input {
    box-sizing: border-box;
    width: 100%;
    height: 80px;
    max-height: 400px;
    padding: 30px 20px;
    border: 1px solid var(--border-common);
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    line-height: 20px;
    background: var(--background-common);
    resize: none;
  }
</style>
